import { Vector } from 'excalibur';

export const dedupeMonotonicX = (points: Vector[]): Vector[] => {
    const out: Vector[] = [];
    let last: Vector | null = null;
    for (const p of points) {
        if (!last) {
            out.push(p);
            last = p;
            continue;
        }
        if (p.x === last.x && p.y === last.y) continue;
        if (p.x < last.x) continue;
        out.push(p);
        last = p;
    }
    return out;
};
